"use client";

import { useEffect } from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { THEME_META_COLORS } from "@/lib/design-system/theme";

export default function ThemeMetaSync() {
  const { resolved } = useTheme();

  useEffect(() => {
    const color = THEME_META_COLORS[resolved];
    let meta = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]',
    );
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    meta.content = color;
  }, [resolved]);

  return null;
}
